import React from 'react';
import { Row, Col, Space } from 'antd';
import Logo from './Logo'; // Make sure the import path is correct

const LogoCloud = ({
    srcs, // Array of image sources
    size = '32px', // Default size for logos
    borderRadius = 4, // Default border radius for logos
    spacing = '10px', // Default spacing between logos
    direction = 'horizontal', // Default direction for logos
    center = false, // New prop to optionally center the logos
}) => {
    // Calculate the span for each column based on the number of items per row
    return (
        <Space
            direction={direction}
            wrap={true}
            style={{
                justifyContent: center ? 'center' : 'start',
                width: '100%'
            }}
        >
            {srcs.map((src, index) => (
                <div style={{ margin: spacing }}>
                    <Logo
                        src={src}
                        width={size}
                        height={size}
                        borderRadius={borderRadius}
                        alt={`Logo ${index + 1}`} // Providing a unique alt text for each logo
                    />
                </div>
            ))}

        </Space>
    );
};

export default LogoCloud;